import { memo } from 'react';
import { Wrapper } from './app-loader.styled';

export const AppLoader = memo(() => {
  return (
    <Wrapper>
      <span className="loader" />
    </Wrapper>
  );
});
